import createStore from "@/utils/create-store";
import Model from "@/models/admin/messages";

export default createStore({ Model });
